import { isArray, isNil, orderBy } from 'lodash';

export function isEmpty(val: any) {
  if (!isNil(val)) {
    if (isArray(val)) {
      return val.length === 0;
    }
    return val === '';
  }
  return true;
}
const map = new Map<string, number>();

export const record = (root = document.body) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL);
  map.clear();
  let node = walker.nextNode();
  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement;
      el.classList.forEach((cls) => {
        map.set(cls, (map.get(cls) || 0) + 1);
      });
    }
    node = walker.nextNode();
  }
};

export const report = (root = document.body, take = 100) => {
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_ALL);

  let node = walker.nextNode();
  const nowMap = new Map<string, number>();
  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
      const el = node as HTMLElement;
      el.classList.forEach((cls) => {
        nowMap.set(cls, (nowMap.get(cls) || 0) + 1);
      });
    }
    node = walker.nextNode();
  }

  const arr = orderBy(
    Array.from(new Set([...map.keys(), ...nowMap.keys()])).map((cls) => ({
      class: cls,
      diff: (nowMap.get(cls) || 0) - (map.get(cls) || 0),
      origin: map.get(cls) || 0,
      current: nowMap.get(cls) || 0
    })),
    'diff',
    'desc'
  );
  // console.log(arr.slice(0, take));
};

export async function scrollToPosition(container: HTMLElement, position: number) {
  position = Math.round(position);

  if (container.scrollTop === position) {
    return Promise.resolve();
  }

  return new Promise<void>((resolve) => {
    let timeoutId: number;

    const scrollListener = () => {
      clearTimeout(timeoutId);

      // scroll is finished when either the position has been reached, or 100ms have elapsed since the last scroll event
      if (container.scrollTop === position) {
        finished();
      } else {
        timeoutId = setTimeout(finished, 100);
      }
    };

    const finished = () => {
      container.removeEventListener('scroll', scrollListener);
      resolve();
    };

    container.addEventListener('scroll', scrollListener);

    container.scrollTo({
      top: position,
      behavior: 'smooth'
    });
  });
}
